var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPodcastStreamlinePlump({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    id: "User-Podcast--Streamline-Plump",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "User Podcast Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-podcast--human-person-share-signal-transmit-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#0f2651",
    d: "M28.799 32.115A9.421 9.421 0 0 0 24 14.585a9.421 9.421 0 0 0 -4.797 17.53c-4.249 1.764 -7.44 5.798 -8.28 10.714 -0.278 1.63 0.648 2.965 2.287 3.184 1.884 0.252 5.153 0.487 10.791 0.487 5.638 0 8.907 -0.235 10.791 -0.487 1.64 -0.22 2.565 -1.553 2.287 -3.184 -0.839 -4.916 -4.032 -8.951 -8.28 -10.714Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 172 (Stroke)",
    fill: "#a0c3ed",
    fillRule: "evenodd",
    d: "M24 8.79c-8.35 0 -15.174 6.806 -15.174 15.27 0 2.511 0.6 4.873 1.66 6.955 0.438 0.857 0.561 1.876 -0.049 2.62 -0.664 0.81 -1.793 1.796 -3.583 2.316 -1.067 0.309 -2.165 -0.255 -2.69 -1.234A22.523 22.523 0 0 1 1.5 24.06C1.5 11.63 11.543 1.5 24 1.5s22.5 10.131 22.5 22.56c0 3.848 -0.964 7.48 -2.665 10.657 -0.524 0.98 -1.623 1.543 -2.689 1.233 -1.79 -0.519 -2.919 -1.505 -3.584 -2.316 -0.61 -0.743 -0.486 -1.762 -0.049 -2.619a15.268 15.268 0 0 0 1.661 -6.955c0 -8.464 -6.824 -15.27 -15.174 -15.27Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPodcastStreamlinePlump);
export default __webpack_public_path__ + "static/media/User-Podcast--Streamline-Plump.042bedbb01f7d6573a0b6c216aed43ec.svg";
export { ForwardRef as ReactComponent };